export default {
    server: 'Unspecified Server Error',
    server2: 'Invalid Username or Password',
    notFound: {
        imagedObject: 'Imaged Object {id} not found',
        edition: 'Edition {id} not found',
    }
};
